export default function Book() {
  return (
    <>
      <button className="btn btn-white rounded-tl-xl rounded-br-xl">
        Book
      </button>
    </>
  )
}
